<template>
    <div>
        <v-row no-gutters class="pt-1">
            <v-col cols="2" align="start">
                <v-btn v-show="showPrevButton" class="" elevation="0" fab dark small @click.stop="onGoPrev" :color="theme.textColor">
                    <v-icon dark opacity="0.5" :color="theme.backgroundColor">
                        mdi-chevron-left
                    </v-icon>
                </v-btn>
            </v-col>
            <v-col cols="8" align="center">
                <div v-if="isStepAac">
                    <!-- Next button -->
                    <v-btn
                        v-if="showNextButton"
                        block
                        large
                        depressed
                        class="white--text"
                        :color="theme.btnColorPrimary"
                        rounded
                        :outlined="false"
                        @click.stop="onGoNext"
                    >
                        <span :style="{ 'color': theme.btnTextColor }">{{ $t('next') }}</span>
                    </v-btn>

                    <!-- Close Button -->
                    <v-btn
                        v-if="singleView"
                        block
                        large
                        depressed
                        class="white--text close-btn"
                        :color="theme.btnColorPrimary"
                        rounded
                        :outlined="false"
                        @click.stop="onClose"
                    >
                        <span :style="{ 'color': theme.btnTextColor }">{{ $t('close') }}</span>
                    </v-btn>
                </div>
                <div v-else-if="isStepTask && !this.isInfoSpot(item)">
                    <!-- Solve and helping button-->
                    <EspButtonGroup
                        ref="btnGroup"
                        :spot="item"
                        :wasAlreadyTouched="wasAlreadyTouched"
                        :disabled="(!hasInput && !isSolutionTypeTextQr(item)) || timeLimitReached || !active || hasCantPlayAgainError || isSlaveInMasterSlaveMode"
                        :showHints="true"
                        :disableCountdown="!(hasCountdown && !timeLimitReached) || hasCantPlayAgainError"
                        :disabledHelp="(!isCheckinAble && !wasAlreadyTouched) || isSlaveInMasterSlaveMode"
                        :startEventDate="checkinSpotDate"
                        :endEventDate="timelimitSpotDate"
                        @click="onSolve"
                        @help="onHelp"
                        @openHint="onHint"
                        @requestHint="onRequestHint"
                        @countdownEnded="onCountdownEnded"
                        @alreadyTouchedClick="onAlreadyTouchedClick"
                    >

                        <EspButtonQrCheckin
                            v-if="isSolutionTypeTextQr(item)"
                            ref="btnQrSolve"
                            :label="$t('info_qr_checkin')"
                            :spot="spot"
                            @success="onQrSolve"
                            :disabled="(!isCheckinAble && !wasAlreadyTouched) || isSlaveInMasterSlaveMode"
                            :fctIsValidCode="isScannedCodeValidSolutionText"
                        />
                        <span v-else>{{ labelTaskSolveSafety }}</span>

                        <template #already-touched>
                            {{ labelTaskAacSafety }}
                        </template>
                    </EspButtonGroup>
                </div>
                <!-- Check in -->
                <div v-else>
                    <EspButtonGroup
                        ref="btnGroup"
                        :spot="item"
                        :wasAlreadyTouched="wasAlreadyTouched"
                        :disabled="(!isCheckinAble && !wasAlreadyTouched) || disabledByMasterSlaveCondition"
                        :disableCountdown="true"
                        :disabledHelp="(!isCheckinAble && !wasAlreadyTouched) || isSlaveInMasterSlaveMode"
                        :startEventDate="checkinSpotDate"
                        :endEventDate="timelimitSpotDate"
                        @click="onButtonGroupClick"
                        @help="onHelp"
                        @openHint="onHint"
                        @countdownEnded="onCountdownEnded"
                        @alreadyTouchedClick="onAlreadyTouchedClick"
                    >
                        <EspButtonPasswordCheckin
                            v-if="isCheckinTypePasswort(item) && !checkinVerified"
                            ref="btnPasswordCheckin"
                            :spot="spot"
                            @success="onCheckin"
                            :disabled="(!isCheckinAble && !wasAlreadyTouched) || isSlaveInMasterSlaveMode"
                            :filled="false"
                            :smallDevice="isXsDevice"
                            :clearable="false"
                            :outlined="false"
                        />
                        <EspButtonQrCheckin
                            v-else-if="isCheckinTypeQr(item) && !checkinVerified"
                            ref="btnQrCheckin"
                            :label="$t('info_qr_checkin')"
                            :spot="spot"
                            @success="onCheckin"
                            :disabled="(!isCheckinAble && !wasAlreadyTouched) || isSlaveInMasterSlaveMode"
                        />
                        <span v-else>{{ calculatedCheckinLabel }}</span>
                        <template #already-touched>
                            {{ calculatedCheckinLabel }}
                        </template>
                    </EspButtonGroup>
                </div>
            </v-col>
            <v-col cols="2" align="end" style="text-align: end;">
                <v-btn v-show="showNextButton" class="" elevation="0" fab dark small @click.stop="onGoNext" :color="theme.textColor">
                    <v-icon dark opacity="0.5" :color="theme.backgroundColor">
                        mdi-chevron-right
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <!-- stepper -->
        <v-row no-gutters class="pt-5" justify="center" :color="theme.headerFooterColor">
            <v-col cols="12" md="10" xl="8" align="center">
                <v-stepper
                    alt-labels
                    class="spotFooter elevation-0 text-caption"
                    style="width:100%"
                    :style="{ 'background-color': theme.backgroundColor }"
                >
                    <v-stepper-header v-if="isTaskSpot(item) && !hideFooter">
                        <!-- no info step without a description, like the native app -->
                        <template v-if="spotHasDescription(item)">
                            <v-stepper-step
                                complete-icon="checkbox-blank-circle-outline"
                                :color="theme.textColor"
                                @click="showIntro"
                                :class="isClickableStepClass(1)"
                                :complete="completedStep1"
                                step=""
                            ><span :style="{'color':theme.textColor}">{{ labelStepperTaskCheckinSafety }}</span>
                            </v-stepper-step>
                            <v-divider :color="theme.backgroundColor"></v-divider>
                        </template>
                        <v-stepper-step
                            complete-icon="checkbox-blank-circle-outline"
                            :color="theme.textColor"
                            @click="showTask"
                            :class="isClickableStepClass(2)"
                            :complete="completedStep2"
                            step=""
                        ><span class="pb-1" :style="{'color':theme.textColor}">{{ labelStepperTaskSolveSafety }}</span>
                        </v-stepper-step>
                        <v-divider :color="theme.backgroundColor"></v-divider>
                        <v-stepper-step
                            complete-icon="checkbox-blank-circle-outline"
                            :color="theme.textColor"
                            @click="showAac"
                            :class="isClickableStepClass(3)"
                            :complete="completedStep3"
                            step=""
                        ><span :style="{'color':theme.textColor}">{{ labelStepperTaskAacSafety }}</span>
                        </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-header v-else-if="isInfoSpot(item) && !hideFooter">
                        <template v-if="spotHasDescription(item)">
                            <v-stepper-step
                                complete-icon="checkbox-blank-circle-outline"
                                :color="theme.textColor"
                                @click="showTask"
                                :class="isClickableStepClass(1)"
                                :complete="completedStep1"
                                step=""
                            ><span :style="{'color':theme.textColor + '!important'}">{{ labelStepperTaskCheckinSafety }}</span></v-stepper-step
                            >
                            <v-divider :color="theme.backgroundColor"></v-divider>
                        </template>
                        <v-stepper-step
                            complete-icon="checkbox-blank-circle-outline"
                            :color="theme.textColor"
                            @click="showAac"
                            :class="isClickableStepClass(3)"
                            :complete="completedStep3"
                            step=""
                        ><span :style="{'color':theme.textColor + '!important'}">{{ labelStepperTaskAacSafety }}</span></v-stepper-step
                        >
                    </v-stepper-header>
                </v-stepper>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import CONFIG from "../../constants/config";
import {EventBus} from "../spots/EventBus";
import {layoutMixin} from "../../utils/layout-mixin";
import {teamMixin} from "../../utils/team-mixin";
import {spotMixin} from "../../utils/spot-mixin";
import EspButtonGroup from "../spots/EspButtonGroup.vue";
import EspButtonPasswordCheckin from "../spots/EspButtonPasswordCheckin.vue";
import EspButtonQrCheckin from "../spots/EspButtonQrCheckin.vue";
import moment from "moment-timezone";

export default {
    mixins:[layoutMixin,spotMixin,teamMixin],
    components:{
        EspButtonPasswordCheckin,
        EspButtonQrCheckin,
        EspButtonGroup
    },
    props:{
        spot:{},
        textColor: {},
        taskInput:{
            type:[String,Array]
        },
        showPrev:{
            type:Boolean,
            default:false
        },
        showNext:{
            type:Boolean,
            default:false
        },
        active:{
            type:Boolean,
            default:false
        },
        singleView:{
            type:Boolean,
            default:false
        },
        hideFooter:{
            type:Boolean,
            default:false
        },
        autoCheckin:{
            type:Boolean,
            default:false
        },
        error:{
            type:Object,
            default:null
        },
        timezone:{
            type:String,
            default:null
        },
        customNames:{
            type:Object,
            default:()=>{
                return {
                    labelTask:null,
                    labelTaskAac:null,
                    labelTaskCheckin:null,
                    labelTaskPass:null,
                    labelTaskSolve:null,
                    labelStepperTaskAac:null,
                    labelStepperTaskCheckin:null,
                    labelStepperTaskSolve:null,
                }
            }
        }
    },
    data() {
        return {
            item:null,
            countdownhasEnded:false,
            wizardStep:1,
            highestWizardStep:1,
            textColorValue: this.textColor,
            tstatusRef: null,
        };
    },
    watch:{
        /* Init data on creation and on update */
        spot: {
            handler(val, oldVal) {
                if (!val) {
                    return;
                }
                this.item=val;
                this.checkSpotWithReachedTimelimit();
                if(!oldVal || val.id!==oldVal.id || val.tstatus!==this.tstatusRef){
                    this.initWizard();
                }
                this.tstatusRef = val.tstatus;
                this.doAutoCheckinIfNessesarry();
            },
            immediate: true,
            deep:true
        }
    },
    updated() {
        this.assignPseudoElementStyle();
    },
    computed:{

        disabledByMasterSlaveCondition(){
            return this.checkinBlockedForSlave(this.item, this.timeLimitReached);
        },
        hasCantPlayAgainError(){
            return !this._.isEmpty(this.error) && this.error.error=="cant_play_again";
        },

        showNextButton(){
            return this.showNext && !this.singleView;
        },
        showPrevButton(){
            return this.showPrev && !this.singleView;
        },
        hasCountdown(){
            return (this.spot && this.spot.answer_time_limit && !this.wasAlreadyTouched)?true:false;
        },
        checkinSpotDate(){
            return (this.spot && this.spot.checkin_time)?moment.tz(this.spot.checkin_time, this.timezone).format():null;
        },
        timelimitSpotDate(){
            if(this.hasCountdown && this.checkinSpotDate){
                let d= moment(this.checkinSpotDate).add(this.spot.answer_time_limit, 'seconds');
                return d.format();
            }
            return null;
        },
        timeLimitReached(){
            //wenn checkin + timelimit größer als jetzt
            return ( this.countdownhasEnded || (this.timelimitSpotDate && (new Date(this.timelimitSpotDate).getTime()< new Date().getTime())))
        },
        isCheckinAble(){
            return !this.spotIsInactive(this.item) && this.active;
        },
        // found by QR scan or password already: the checkin step takes the plain button
        checkinVerified(){
            return this.isCheckinVerified(this.item);
        },
        hasInput(){
            // if (this.isSolutionTypeVoting(this.item)) {
            //     const isVotingZeroVotes = this.item.raetsel.max_votes === 0 ? true : false;
            //     return ((this.taskInput && this.taskInput.length>0) || isVotingZeroVotes);
            // }else{
            return (this.taskInput && this.taskInput.length>0);
            //}

        },
        loadingWasSuccessful(){
            return !this.isLoadingSpot;
        },
        isCheckedIn(){
            // console.log('show scan code: ', this.spotIsCheckedIn(this.item)&&this.isSolutionTypeTextQr(this.item));
            return this.spotIsCheckedIn(this.item);
        },
        isSolved(){
            return this.spotIsSolved(this.item);
        },
        isFailed(){
            return this.spotIsFailed(this.item);
        },
        wasAlreadyTouched(){
            return (this.isSolved || this.isFailed);
        },
        isInactive(){
            return this.spotIsInactive(this.item);
        },
        showAfterAnser(){
            return this.isCheckedIn &&(this.isSolved || this.isFailed);
        },
        completedStep1(){
            return this.wizardStep >= CONFIG.TASK_STEPPER_CHECKIN;
        },
        completedStep2(){
            return this.wizardStep >= CONFIG.TASK_STEPPER_TASK;
        },
        completedStep3(){
            return this.wizardStep >= CONFIG.TASK_STEPPER_AAC;
        },
        isStepCheckin(){
            return this.wizardStep == CONFIG.TASK_STEPPER_CHECKIN;
        },
        isStepTask(){
            return this.wizardStep == CONFIG.TASK_STEPPER_TASK;
        },
        isStepAac(){
            return this.wizardStep == CONFIG.TASK_STEPPER_AAC;
        },
        labelTaskCheckinSafety(){
            return (this.customNames && !this._.isEmpty(this.customNames.labelTaskCheckin))?this.customNames.labelTaskCheckin:this.$t('taskActive', { task: this.labelTaskSafety });
        },
        labelTaskPassSafety(){
            return (this.customNames && !this._.isEmpty(this.customNames.labelTaskPass))?this.customNames.labelTaskPass:this.$t('taskCheckin');
        },
        labelCheckinPasswort(){
            return this.$t('password-checkin')
        },
        labelTaskAacSafety(){
            return (this.customNames && !this._.isEmpty(this.customNames.labelTaskAac))?this.customNames.labelTaskAac:this.$t('taskFeedback');
        },
        labelTaskSafety(){
            return (this.customNames && !this._.isEmpty(this.customNames.labelTask))?this.customNames.labelTask:this.$t('menuTask');
        },
        labelTaskSolveSafety(){
            if(this.timeLimitReached){
                return this.$t('correctWasMedia')
            }
            if(this.hasCantPlayAgainError){
                return this.$t("errorCodeCantPlayAgain");
            }
            if(this.isSlaveInMasterSlaveMode){
                return this.$t('app_task_blocked_by_master')
            }
            return (!this.active)?this.$t('taskEventNotActive', { event: this.$t('event') }):(this.customNames && !this._.isEmpty(this.customNames.labelTaskSolve))?this.customNames.labelTaskSolve:this.$t('taskSolve', { task: this.labelTaskSafety });
        },
        labelStepperTaskCheckinSafety(){
            return (this.customNames && !this._.isEmpty(this.customNames.labelStepperTaskCheckin))?this.customNames.labelStepperTaskCheckin:this.$t('taskInfo');
        },
        labelStepperTaskAacSafety(){
            return (this.customNames && !this._.isEmpty(this.customNames.labelStepperTaskAac))?this.customNames.labelStepperTaskAac:this.$t('taskFeedback');
        },
        labelStepperTaskSolveSafety(){
            return this.labelTaskSafety
        },
        calculatedCheckinLabel(){
            if(this.disabledByMasterSlaveCondition){
                return this.$t('app_task_blocked_by_master')
            }
            if(!this.active && !this.wasAlreadyTouched){
                return this.$t('taskEventNotActive', { event: this.$t('event') });
            }
            if(this.spotIsInactive(this.item)){
                return this.$t('taskInactive');
            }
            return this.isInfoSpot(this.item)?this.labelTaskPassSafety:this.labelTaskCheckinSafety;
        }

    },
    methods:{

        checkSpotWithReachedTimelimit(){
            this.$nextTick(() => {
                if(this.timeLimitReached && !this.spotAlreadyTouched(this.item)){
                    this.onCountdownEnded();
                }
            });
        },

        initWizard(){
            //Set step by spot solve state
            this.$nextTick(() => {
                if(this.showAfterAnser){
                    this.goToWizardStep(CONFIG.TASK_STEPPER_AAC);
                }else if(this.isCheckedIn){
                    if(this.isInfoSpot(this.item)){
                        this.goToWizardStep(CONFIG.TASK_STEPPER_AAC);
                    }else{
                        this.goToWizardStep(CONFIG.TASK_STEPPER_TASK);
                    }
                }else{
                    this.goToWizardStep(CONFIG.TASK_STEPPER_CHECKIN);
                }

                if(this.highestWizardStep<this.wizardStep){
                    this.highestWizardStep=this.wizardStep;
                }
            });
        },
        goToWizardStep(step) {
            this.wizardStep=step;
            this.$emit('changedWizardStep',step);
        },

        isClickableStepClass(step){
            return (step<=this.highestWizardStep)?'clickableStep':'';
        },
        onImageClick(index){
            console.log(index);
        },
        onGoNext(){
            this.$emit('next')
        },
        onGoPrev(){
            this.$emit('prev')
        },
        onClose(){
            this.$emit('close')
        },
        onPasswordCheckin(){
            if(this.$refs.btnPasswordCheckin){
                this.$refs.btnPasswordCheckin.checkPassword();
            }
        },
        onQrCheckin(){
            //TODO: is something todo here?
            /*
            if(this.$refs.btnQrCheckin){
              this.$refs.btnQrCheckin.checkQr();
            }*/
        },
        onCheckin(){
            if (this.wasAlreadyTouched) {
                if(this.isInfoSpot(this.item)){
                    this.showAac();
                }else{
                    this.showTask();
                }
            } else {
                this.$emit('checkin');
                // this.goToWizardStep(CONFIG.TASK_STEPPER_TASK);
            }
        },
        onButtonGroupClick(val){
            if(this.checkinVerified){
                this.onCheckin(val);
            }
            else if(this.isCheckinTypePasswort(this.item)){
                this.onPasswordCheckin(val);
            }
            else if(this.isCheckinTypeQr(this.item)){
                this.onQrCheckin(val);
            }
            else{
                this.onCheckin(val);
            }
        },
        onQrSolve(solution){
            // console.log('onQrSolve: ', solution);
            this.onSolve(false, solution);
        },
        onSolve(sendEmptyUserInput, solution){
            if( this.isSolutionTypeTextQr(this.item) && !solution){
                // Stop click propagation from EspButtonQrCheckin. The click was handled with onQrSolve
                return;
            }
            //we emit to parent the user interaction
            this.$emit('solve',sendEmptyUserInput, solution);
            //we will trigger the stop countdown only if task is been solved or failed
            if( this.hasCountdown && (this.isSolved || this.isFailed) ){
                this.stopCountdown('btnGroup');
            }
        },
        onHelp(val){
            this.$emit('help',val);
        },
        onHint(spot){
            EventBus.$emit(CONFIG.EVENT_BUS_OPEN_SPOT,spot);
        },
        onRequestHint(hintId) {
            this.$emit('requestHint', hintId);
        },
        onCountdownEnded(){
            let sendEmptyUserInput=true;
            this.onSolve(sendEmptyUserInput);
        },
        isScannedCodeValidSolutionText(val){
            if(typeof(val)=="string"){
                return true;
            }
            else{
                return false;
            }
        },
        stopCountdown(refName){
            if(this.$refs && this.$refs[refName]){
                this.$refs[refName].stopCountdown()
            }
        },
        showIntro(){
            this.goToWizardStep(CONFIG.TASK_STEPPER_CHECKIN);
        },
        showTask(){
            if(this.isCheckedIn){
                this.goToWizardStep(CONFIG.TASK_STEPPER_TASK);
            }
        },
        showAac(){
            if(this.showAfterAnser){
                this.goToWizardStep(CONFIG.TASK_STEPPER_AAC);
            }
        },
        onAlreadyTouchedClick() {
            if (this.wizardStep === CONFIG.TASK_STEPPER_CHECKIN){
                this.goToWizardStep(CONFIG.TASK_STEPPER_TASK);
            } else if(this.showAfterAnser) {
                this.goToWizardStep(CONFIG.TASK_STEPPER_AAC);
            }
        },
        setHelpSystemState(searchedSpot){
            if(this.$refs.btnGroup){
                this.$refs.btnGroup.setHelpSystemState(searchedSpot);
            }
        },
        doAutoCheckinIfNessesarry(){
            if(this.autoCheckin){
                this.onCheckin();
            }
        },
        assignPseudoElementStyle() {
            this.textColorValue = this.theme.textColor;
            document.documentElement.style.setProperty('--span-text-color', this.textColorValue);
        }
    }
}
</script>

<style lang="scss">
.spotFooter .v-stepper__step {
    padding: 0 !important;
}
.spotFooter .v-stepper__step__step {
    height: 14px;
    width: 15px;
    min-width: 15px;
    //  color: var(--span-text-color) !important;
}
.spotFooter hr {
    margin-top: 8px !important;
}
//.spotFooter .v-stepper__step--complete {
//opacity: 0.5 !important;
//color: var(--span-text-color) !important;
//}
//
//.v-stepper {
//  .v-stepper__label {
//    color: var(--span-text-color) !important;
//  }
//}

.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
    opacity: 0.5 !important;
    background-color: var(--span-text-color) !important;
}
.spotFooter .clickableStep {
    cursor: pointer;
}

.spotGroupedButton.v-btn-toggle > .v-btn.v-btn {
    opacity: 1 !important;
}

.close-btn {
    margin-top: 40px;
    @media screen and (max-width: 960px) {
        margin-top: 20px;
    }
}
</style>
